import { ValidatorFn, Validators } from '@angular/forms';
import { GrocyOpenProduct } from '../../../../core/entities/grocy/product-actions/product-action.entity';
import { GrocyQuantityUnitBasics } from '../../../../core/entities/grocy/quantity-units/quantity-unit-basics.entity';
import { GrocyStockEntry } from '../../../../core/entities/grocy/stock-entries/stock-entry.entity';
import { positive } from '../../../../forms/form-control-options.constants';
import { GrocyDashboardQuickActionOpenFormControls } from '../form-controls/dashboard-quick-action.form-controls';
import { GrocyDashboardQuickActionForm } from './dashboard-quick-action.form';

export class GrocyDashboardQuickActionOpenForm extends GrocyDashboardQuickActionForm<GrocyDashboardQuickActionOpenFormControls> {
  formGroup = this.createFormGroup(GrocyDashboardQuickActionOpenFormControls);

  public get amountHint(): string | undefined {
    return undefined;
  }

  public get productAction(): GrocyOpenProduct {
    const productAction: GrocyOpenProduct = {
      amount: this.amount,
      productId: this.selectedProduct!.id,
    };

    if (this.controls.stockEntry.value) {
      productAction.stockEntryId = this.controls.stockEntry.value.stockId;
    }

    return productAction;
  }

  public get quantityUnit(): GrocyQuantityUnitBasics | undefined {
    return this.selectedProduct?.quantityUnits.stock;
  }

  public override canSelectStockEntry(stockEntry: GrocyStockEntry): boolean {
    return !stockEntry.open;
  }

  public setAmountToMax(): void {
    if (this.selectedProduct) {
      const { value: stockEntry } = this.controls.stockEntry;
      const { stockAmount, stockAmountOpened } = this.selectedProduct;

      if (stockEntry && !stockEntry.open) {
        this.controls.amount.setValue(stockEntry.amount);
      } else {
        this.controls.amount.setValue((stockAmount || 0) - (stockAmountOpened || 0));
      }
    }
  }

  protected setChangeListeners(): void {
    this.controls.stockEntry.valueChanges.subscribe(stockEntry => {
      let maxAmount = (this.selectedProduct?.stockAmount || 0) - (this.selectedProduct?.stockAmountOpened || 0);

      if (stockEntry) {
        maxAmount = stockEntry.openedAt ? 0 : stockEntry.amount;
      }

      if (maxAmount > 0) {
        this.controls.amount.setValue(this.selectedProduct?.defaultAmount || 1);
      }

      this.controls.amount.setValidators([Validators.required, Validators.min(0.000001), Validators.max(maxAmount)]);

      this.controls.amount.updateValueAndValidity();
    });
  }

  protected setInitialValues(): void {
    this.controls.amount.setValidators([
      ...(positive.validators as ValidatorFn[]),
      Validators.max((this.selectedProduct?.stockAmount || 0) - (this.selectedProduct?.stockAmountOpened || 0)),
    ]);
  }
}
